import { themeData1 } from './theme-data/theme-data-1';
import { themeData2 } from './theme-data/theme-data-2';
import { themeData3 } from './theme-data/theme-data-3';
import { themeData4 } from './theme-data/theme-data-4';
import { themeData5 } from './theme-data/theme-data-5';
import { themeData6 } from './theme-data/theme-data-6';

export const ThemeData = {
  'theme-1': themeData1,
  'theme-2': themeData2,
  'theme-3': themeData3,
  'theme-4': themeData4,
  'theme-5': themeData5,
  'theme-6': themeData6
};
